import { BsGlobe } from "react-icons/bs";
import { MdOutlinePhonelinkRing, MdEmail } from "react-icons/md";
import { FaGraduationCap } from "react-icons/fa6";
import { IoLocationSharp } from "react-icons/io5";
import { useRef, useState } from "react";
import emailjs from "@emailjs/browser";
import { mail } from "../../projectConfig";

const Result = () => {
  return (
    <small>Your message has been succesfully sent. I will respond asap!</small>
  );
};
export default function Contact() {
  const [result, showResult] = useState(false);

  const sendEmail = (e) => {
    e.preventDefault();

    emailjs
      .sendForm(
        "service_ysbsje6",
        "template_bj80fks",
        form.current,
        "uB_TKUF9en3o4FF1-"
      )
      .then(
        (result) => {
          console.log(result.text);
        },
        (error) => {
          console.log(error.text);
        }
      );
    e.target.reset();
    showResult(true);
  };
  setTimeout(() => {
    showResult(false);
  }, 5000);

  const form = useRef();

  return (
    <div className="mt-[40px] md:mt-[120px] mb-20">
      <div className="smallC">
        <h1 className="contactH text-center">
          <span className="otherH">&lt;</span>
          <span className="get" data-clip="Get in touch with me">
            Get in touch with me
          </span>
          <span className="otherH"> /&gt;</span>
        </h1>
        <p className="w-full md:w-[60%] mx-auto text-base md:text-lg text-center">
          <span className="text-secondary text-base md:text-lg">" </span>If you
          have amazing project(s) you would like us to work on, send me a
          message below, you can also reach me on my social media handles{" "}
          <span className="text-secondary text-base md:text-lg">" </span>
        </p>
        <div className="mt-4 md:!mt-10 grid items-start gap-5 md:grid-cols-2">
          <form
            action=""
            onSubmit={sendEmail}
            className="flex flex-col gap-3 md:!gap-5 w-full"
            ref={form}
          >
            <input
              className="border-none bg-[#D9D9D9] dark:bg-white/20 p-3 rounded-xl w-full"
              type="text"
              name="fullName"
              placeholder="Full Name"
              required
            />
            <input
              className="border-none bg-[#D9D9D9] dark:bg-white/20 p-3 rounded-xl w-full"
              type="text"
              name="email"
              placeholder="Your Email Address"
              required
            />
            <div>
              <textarea
                className="border-none bg-[#D9D9D9] dark:bg-white/20 p-3 rounded-xl w-full"
                name="message"
                placeholder="Your Message"
                required
                rows="6"
              ></textarea>
              <div className="btn-hover">
                <button className="my-4 btnC">
                  <span className="span1"></span>
                  <span className="span2"></span>
                  Send
                </button>
              </div>
            </div>

            {result ? <Result /> : null}
          </form>
          <div className="text-black/70 dark:text-white/70">
            <p className="w-full text-sm md:text-base text-center">
              <span className="text-secondary text-base md:text-lg">"</span>It
              is often in the darkest skies that we see the brightest stars.
              <span className="text-secondary text-base md:text-lg">" </span>
              <span className="text-black dark:!text-white">
                {" - "}
                Ephraim Udazi.
              </span>
            </p>
            <div className="mt-4 -mx-4 md:mx-0 w-full flex flex-col gap-3 text-xs md:text-sm">
              <div className="flex items-center justify-between w-full">
                <div className="flex gap-2 items-center">
                  <BsGlobe />
                  <p>Language</p>
                </div>
                <div>
                  <p className="whitespace-nowrap">
                    English (Fluent), German (Basic)
                  </p>
                </div>
              </div>
              <div className="flex items-center justify-between w-full">
                <div className="flex gap-2 items-center">
                  <FaGraduationCap />
                  <p>Education</p>
                </div>
                <div>
                  <p className="whitespace-nowrap">University of Benin.</p>
                </div>
              </div>
              <div className="flex items-center justify-between w-full">
                <div className="flex gap-2 items-center">
                  <MdEmail />
                  <p>Email</p>
                </div>
                <div>
                  <a href={mail} target="_blank" rel="noopener noreferrer">
                    <p className="whitespace-nowrap">udazi.osebest@gmail.com</p>
                  </a>
                </div>
              </div>
              <div className="flex items-center justify-between w-full">
                <div className="flex gap-2 items-center">
                  <MdOutlinePhonelinkRing />
                  <p>Phone</p>
                </div>
                <div>
                  <a href="tel:+2348156466658">
                    <p className="whitespace-nowrap">+2348156466658</p>
                  </a>
                </div>
              </div>
              <div className="flex items-center justify-between w-full">
                <div className="flex gap-2 items-center">
                  <IoLocationSharp />
                  <p>Location</p>
                </div>
                <div>
                  <p className="whitespace-nowrap">Port Harcourt</p>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
}
